import * as T from './actiontypes';

// 存储用户信息
export const setAuth = (auth) => ({
    type: T.SET_AUTH,
    payload: auth
});